module.exports = __webpack_public_path__ + "static/media/estatDelMar.6519c600.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/avis/estatDelMar.svg
// module id = 824
// module chunks = 0